<template>
  <div>
    <!-- Alert: No item found -->
    <b-alert
      variant="danger"
      :show="user === undefined"
    >
      <h4 class="alert-heading">
        Error fetching user data
      </h4>
      <div class="alert-body">
        No user found with this user id. Check
        <b-link
          class="alert-link"
          :to="{ name: 'apps-users-list'}"
        >
          User List
        </b-link>
        for other users.
      </div>
    </b-alert>

    <template v-if="user">
      <!-- First Row -->
      <b-row>
        <b-col
          cols="12"
          xl="9"
          lg="8"
          md="7"
        >
          <user-view-user-info-card :user-data="user" />
        </b-col>
        <b-col
          cols="12"
          md="5"
          xl="3"
          lg="4"
        >
          <user-view-user-plan-card :user-data="user" />
        </b-col>
      </b-row>
<!-- 
      <b-row>
        <b-col
          cols="12"
          lg="6"
        >
          <user-view-user-permissions-card
            :user-data="user"
          />
        </b-col>
        <b-col
          cols="12"
          lg="6"
        >
          <user-view-user-timeline-card
            :user-data="user"
          />
        </b-col>        
      </b-row> -->

      <div class="col-12">
        <div class="card">
          <div class="card-header border-bottom">
            <h4 class="card-title">
              Courses
            </h4>
          </div>
          <div class="card-datatable">
            <table class="datatables-ajax table">
              <thead>
                <tr>
                  <th>SN</th>
                  <th>Course</th>
                  <th>Code</th>
                  <th>Fee</th>
                  <th>Discount</th>
                  <th>Type</th>
                  <th>Date</th>
                  <th>Status</th>
                </tr>
              </thead>
              <tfoot>
                <tr>
                  <th>SN</th>
                  <th>Course</th>
                  <th>Code</th>
                  <th>Fee</th>
                  <th>Discount</th>
                  <th>Type</th>
                  <th>Date</th>
                  <th>Status</th>
                </tr>
              </tfoot>
              <tbody>
                <tr v-if="!user.courses.length">
                  <td colspan="8" class="text-center">No courses found</td>
                </tr>
                <tr
                  v-else
                  v-for="(course, index) in user.courses"
                  :key="index"
                >
                  <td>{{ index + 1 }}</td>
                  <td>{{ course.title }}</td>
                  <td>{{ course.code }}</td>
                  <td>{{ course.fee }}</td>
                  <td>{{ course.discount }}</td>
                  <td>
                    {{ course.type }}
                  </td>
                  <td>{{ course.created_at_formatted }}</td>
                  <td :class="course.isActive ? 'text-success' : 'text-danger'">
                    {{ course.isActive ? 'Active' : 'Not Active' }}
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
        <nav aria-label="Page navigation">
          <ul class="pagination">
            <li :class="link.active ? 'page-item active' : 'page-item'" v-for="link in pageMeta.links" :key="link.id">
              <a class="page-link" href="javascript:;" @click="paginate(link.url)" v-html="link.label"></a>
            </li>
          </ul>
        </nav>             
      </div>
    </template>
  </div>
</template>

<script>
import router from '@/router'
import {
  BRow, BCol, BAlert, BLink,
} from 'bootstrap-vue'
import InvoiceList from '@/views/apps/invoice/invoice-list/InvoiceList.vue'
import UserViewUserInfoCard from './UserViewUserInfoCard.vue'
import UserViewUserPlanCard from './UserViewUserPlanCard.vue'
import UserViewUserTimelineCard from './UserViewUserTimelineCard.vue'
import UserViewUserPermissionsCard from './UserViewUserPermissionsCard.vue'

export default {
  components: {
    BRow,
    BCol,
    BAlert,
    BLink,

    // Local Components
    UserViewUserInfoCard,
    UserViewUserPlanCard,
    UserViewUserTimelineCard,
    UserViewUserPermissionsCard,

    InvoiceList,
  },
  data() {
    return {
      user: {},
      transactions: [],
      trans: [],
      url: '',
      links:{},
      pageMeta: {},
    }
  },
  methods: {
    getTransactions() {
      this.$http.get(this.url)
        .then(response => {
          if(response.data.status === true) {
            this.transactions = response.data.data.data
            this.links = response.data.data.links
            this.pageMeta = response.data.data.meta
          }
        })
    },
    paginate(url) {
      this.url = url
      this.getTransactions()
    },        
  },
  created() {
    this.$http.get(`${this.$url}/student/${router.currentRoute.params.id}`)
      .then(response => {
        this.user = response.data.data
        this.url = this.$url+`/student/courses/${this.user.id}`
        // this.getTransactions()        
        // this.trans = this.user.transactions
        // console.log(this.user)
      })
  },
}
</script>

<style>

</style>
